// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"594":"about","711":"friend"}[chunkId] || chunkId) + "." + {"18":"d57f9827","594":"55c3732b","711":"92516762"}[chunkId] + ".js";
};